/**
 * Utility functions for parsing and handling quantity values
 * across different measurement types and data sources
 */

/**
 * Safely parse quantity value from string or number
 * @param value - The value to parse (string | number)
 * @param defaultValue - Default value if parsing fails (default: 0)
 * @returns Parsed number value
 */
export function parseQuantity(
  value: string | number | null | undefined,
  defaultValue: number = 0
): number {
  if (value === null || value === undefined) return defaultValue

  const numValue = typeof value === 'string' ? parseFloat(value) : value
  return isNaN(numValue) ? defaultValue : numValue
}

/**
 * Parse quantity with fallback to 1 for required fields
 * Useful for maintenance task parts and other non-zero defaults
 */
export function parseRequiredQuantity(
  value: string | number | null | undefined
): number {
  return parseQuantity(value, 1)
}

/**
 * Parse quantity allowing null for optional fields like reorderLevel
 */
export function parseOptionalQuantity(
  value: string | number | null | undefined
): number | null {
  if (value === null || value === undefined) return null
  return parseQuantity(value, 0)
}
